import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const undoToast = (ent, message, invalidate, opts = {}) => toast.success(message, {
  ...opts,
  duration: 8000,
  action: {
    label: "Undo",
    onClick: async () => {
      try {
        await api.post(`/entities/${ent.id}/undo-last`);
        invalidate(["entities", ent.universe_id], ["entity", ent.id], ["history", ent.id]);
        toast.success(`Undone: ${ent.name} is back to how it was`);
      } catch (e) {
        toast.error(errMsg(e));
      }
    },
  },
});
